/* istanbul ignore file */
import fr from './translations/fr.json';
import en from './translations/en.json';

const locales = { en, fr };
export default locales;
